export default {
    name: 'OCPP 伺服器',
    fields: {
        id: 'ID',
        name: '名稱',
        description: '描述',
        endpointUrl: '端點網址',
        apiKey: 'API 金鑰', // Keep for backward compatibility
        webhookSecret: 'Webhook 密鑰', // Keep for backward compatibility
        ocppToBackendApiKey: 'OCPP 到後端 API 金鑰',
        backendToOcppApiKey: '後端到 OCPP API 金鑰',
        elkKey: 'ELK 金鑰',
        status: '狀態',
        environment: '環境',
        isPrimary: '主要',
        capabilities: '功能',
        config: '配置',
        ipWhitelist: 'IP 白名單',
        lastHeartbeat: '最後心跳',
        version: '版本',
        loadGroups: '負載群組',
        createdAt: '建立時間',
        updatedAt: '更新時間',
    },
    list: {
        title: 'OCPP 伺服器',
        filters: {
            search: '按名稱或描述搜尋',
        },
    },
    create: {
        title: '建立 OCPP 伺服器',
        subtitle: '配置新的 OCPP 伺服器以管理充電器',
        backToList: '返回 OCPP 伺服器列表',
        infoMessage: 'OCPP 伺服器管理充電站並在分散式系統中提供負載管理。',
        basicInfo: '基本資訊',
        connectionConfig: '連線配置',
        supabaseConnection: 'Supabase 連線',
        supabaseConnectionHelperText: 'OCPP 伺服器需要 Supabase 連線來管理充電資料和時段。',
        supabaseConnectionSelectHelperText: '為此 OCPP 伺服器選擇 Supabase 連線',
        securityConfig: '安全配置',
        statusConfig: '狀態配置',
        advancedConfig: '進階配置',
        advancedConfigMessage: '配置進階伺服器功能和設定。留空使用預設值。',
        securityHelperText: '如果未提供，API 金鑰和 Webhook 密鑰將自動產生。',
        nameHelperText: '輸入此 OCPP 伺服器的唯一描述性名稱',
        descriptionHelperText: '可選的伺服器用途和位置描述',
        endpointUrlHelperText: '可存取 OCPP 伺服器或其 API 的完整網址（例如：ws://localhost:8888 用於 WebSocket，http://localhost:8787 用於 HTTP API）',
        statusHelperText: '設定初始狀態 - 新伺服器通常為「待處理」',
        apiKeyHelperText: '此金鑰用於 OCPP 伺服器對後端進行身份驗證。請複製並安全地保存在您的 OCPP 伺服器配置中。',
        webhookSecretHelperText: '此密鑰用於驗證後端對 OCPP 伺服器的 Webhook 呼叫。請複製並安全地保存。',
        ocppToBackendApiKeyHelperText: '此金鑰由 OCPP 伺服器在呼叫後端 API 時用於身份驗證。請複製並保存在您的 OCPP 伺服器配置檔案中。',
        backendToOcppApiKeyHelperText: '此金鑰由後端在呼叫 OCPP 伺服器 API 時用於身份驗證。它將被安全地儲存在後端。',
        keysWarningTitle: '重要：請立即保存這些金鑰！',
        keysWarningMessage: '這些金鑰將被安全儲存，建立後無法再次取得。請確保在儲存前複製它們。',
        keysAutoGenerated: '自動產生金鑰',
        regenerateKeys: '重新產生金鑰',
        copied: '已複製！',
        copyToClipboard: '複製到剪貼簿',
        keyWillBeDisplayedAs: '儲存後，此金鑰將顯示為',
        capabilitiesHelperText: '描述伺服器功能的 JSON 物件（例如：{"supportsLMS": true}）',
        configHelperText: '伺服器特定設定的 JSON 配置',
        ipWhitelistHelperText: '允許的 IP 範圍的 JSON 陣列（例如：["192.168.1.0/24"]）',
    },
    edit: {
        title: '編輯 OCPP 伺服器',
        backToList: '返回 OCPP 伺服器列表',
        basicInfo: '基本資訊',
        connectionConfig: '連線配置',
        supabaseConnection: 'Supabase 連線',
        supabaseConnectionHelperText: '管理此 OCPP 伺服器的 Supabase 連線。',
        supabaseConnectionSelectHelperText: '為此伺服器選擇新的 Supabase 連線',
        securityConfig: '安全配置',
        statusConfig: '狀態配置',
        advancedConfig: '進階配置',
        deleteServer: '刪除伺服器',
        advancedConfigMessage: '配置進階伺服器功能和設定。留空使用預設值。',
        securityWarning: '重新產生金鑰將使現有連線失效。重新產生後請更新您的 OCPP 伺服器配置。',
        nameHelperText: '更新伺服器名稱（必須唯一）',
        descriptionHelperText: '更新伺服器描述',
        endpointUrlHelperText: '更新此 OCPP 伺服器的網址（WebSocket 或 HTTP API）',
        statusHelperText: '變更伺服器狀態以控制可用性',
        apiKeyHelperText: '目前的 API 金鑰（使用重新產生按鈕建立新的）',
        webhookSecretHelperText: '目前的 Webhook 密鑰（使用重新產生按鈕建立新的）',
        ocppToBackendApiKeyHelperText: 'OCPP 伺服器用於向後端進行身份驗證的目前 API 金鑰（使用重新產生按鈕建立新的）',
        backendToOcppApiKeyHelperText: '後端用於向 OCPP 伺服器進行身份驗證的目前 API 金鑰（使用重新產生按鈕建立新的）',
        capabilitiesHelperText: '以 JSON 格式更新伺服器功能',
        configHelperText: '以 JSON 格式更新伺服器配置',
        ipWhitelistHelperText: '以 JSON 陣列格式更新 IP 白名單',
        regenerateApiKey: '重新產生 API 金鑰',
        regenerateWebhookSecret: '重新產生 Webhook 密鑰',
        regenerateBothKeys: '重新產生兩個金鑰',
        newKeysWarningTitle: '新金鑰已產生！請立即保存。',
        newKeysWarningMessage: '這是您的新金鑰。請在它們消失前複製並更新您的 OCPP 伺服器配置。',
        newApiKey: '新 API 金鑰',
        newWebhookSecret: '新 Webhook 密鑰',
        newOcppToBackendApiKey: '新 OCPP 到後端 API 金鑰',
        newBackendToOcppApiKey: '新後端到 OCPP API 金鑰',
        keysCannotBeRetrieved: '金鑰被安全儲存且建立後無法取回。如需要請使用重新產生按鈕建立新金鑰。',
        elkKeySection: 'ELK Stack API 金鑰',
        regenerateElkKey: '重新產生 ELK API 金鑰',
        noElkKeyConfigured: '此伺服器未配置 ELK API 金鑰。ELK 日誌記錄已停用。',
        confirmElkKeyRegeneration: '確認重新產生 ELK 金鑰',
        elkKeyRegenerationWarning: '重新產生 ELK API 金鑰將立即使舊金鑰失效。OCPP 伺服器需要使用新金鑰重新啟動才能繼續記錄到 Elasticsearch。',
        elkKeyRegenerationConfirm: '您確定要重新產生 ELK API 金鑰嗎？',
        confirmRegenerate: '是的，重新產生',
        cannotDeleteWithLoadGroups: '無法刪除有 {count} 個已分配負載群組的伺服器',
        deleteServerDescription: '永久刪除此 OCPP 伺服器配置',
        deleteConfirmTitle: '確認刪除伺服器',
        deleteConfirmWarning: '這將永久刪除 OCPP 伺服器配置。',
        deleteConfirmMessage: '您即將永久刪除',
        deleteConfirmInfo: '此操作無法復原。',
        deleteConfirmPrompt: '要確認刪除，請輸入',
        deleteConfirmPromptBelow: '如下：',
        deleteConfirmTypePlaceholder: '輸入 {name} 以確認',
        nameDoesNotMatch: '伺服器名稱不符',
        deleteButton: '刪除伺服器',
    },
    elkKey: {
        title: '儲存新的 ELK API 金鑰',
        warningTitle: '重要：請立即儲存此金鑰！',
        warningMessage: '此新的 ELK API 金鑰只會顯示一次，之後無法取回。舊金鑰已失效。',
        label: '新的 Elasticsearch API 金鑰',
        helperText: '使用此新金鑰更新您的 OCPP 伺服器配置並重新啟動伺服器。',
        confirmButton: '我已儲存金鑰',
    },
    elkConfig: {
        title: 'ELK 日誌記錄配置',
        description: '配置此 OCPP 伺服器的 Elasticsearch 日誌記錄設定。這些設定控制批次處理、緩衝和溢位行為。',
        batchSize: '批次大小',
        batchSizeHelper: '在發送到 Elasticsearch 之前批次處理的日誌數量（10-1000）。較高的數值可減少網路開銷。',
        batchTimeout: '批次逾時（毫秒）',
        batchTimeoutHelper: '在刷新批次之前等待的最長時間（毫秒，1000-300000）。即使批次未滿，在此逾時後也會發送日誌。',
        maxBufferSize: '最大緩衝區大小',
        maxBufferSizeHelper: '當 ELK 不可用時在記憶體中緩衝的最大日誌數量（1000-100000）。防止記憶體溢位。',
        spilloverEnabled: '啟用溢位',
        spilloverEnabledHelper: '當記憶體緩衝區已滿時將日誌寫入磁碟。建議啟用以防止 ELK 中斷期間的日誌丟失。',
        spilloverRetention: '溢位保留期（天）',
        spilloverRetentionHelper: '自動刪除溢位日誌檔案之前保留的天數（1-30）。檔案會在此期間後自動清理。',
    },
    sections: {
        basic: '基本資訊',
        connection: '連線設定',
        capabilities: '伺服器功能',
        configuration: '進階配置',
        metadata: '中繼資料',
        dangerZone: '危險區域',
    },
    tabs: {
        general: '一般',
        metadata: '中繼資料',
        danger: '危險區域',
    },
    statuses: {
        pending: '待處理',
        active: '啟用',
        inactive: '停用',
        maintenance: '維護中',
        retired: '已停用',
    },
    capabilities: {
        title: '伺服器功能',
        description: '配置此 OCPP 伺服器支援的功能',
        remoteCommands: '遠端命令',
        smartCharging: '智慧充電',
        firmwareUpdate: '韌體更新',
        localAuthList: '本地授權清單',
        reservations: '預約',
        lms: 'LMS 支援',
        chargingProfiles: '充電配置',
        none: '未配置功能',
        supportsLMS: '支援負載管理系統',
        supportsChargingProfiles: '支援充電配置',
        maxConcurrentSessions: '最大並發時段數',
        maxConcurrentSessionsHelper: '此伺服器可同時處理的最大充電時段數',
        supportsRemoteCommands: '支援遠端命令',
        supportsSmartCharging: '支援智慧充電',
        supportsFirmwareUpdate: '支援韌體更新',
        supportsLocalAuthList: '支援本地授權清單',
        supportsReservations: '支援預約',
    },
    config: {
        title: '伺服器配置',
        description: '配置進階 OCPP 伺服器設定。所有數值都有合理的預設值。',
        sections: {
            server: '伺服器配置',
            lmsCore: 'LMS 核心配置',
            lmsMessage: 'LMS 訊息配置',
            lmsTime: 'LMS 時間配置',
        },
        fields: {
            // 伺服器配置
            port: '伺服器連接埠',
            logOcppMessages: '記錄 OCPP 訊息',
            heartbeatInterval: '心跳間隔',
            meterValueInterval: '電表數值間隔',
            enableAuth: '啟用認證',
            enableLMS: '啟用負載管理',

            // LMS 核心配置
            rebalanceInterval: '負載重新平衡間隔',
            minRebalanceInterval: '最小重新平衡間隔',
            lmsIecMinimumCurrent: 'IEC 最小電流',
            lmsPracticalMinimumCurrent: '實際最小電流',
            lmsHysteresisThreshold: '遲滯閾值',
            lmsProfileRefreshInterval: '充電配置檔重新整理間隔',
            lmsFailSafeCheckInterval: '故障安全檢查間隔',

            // LMS 訊息配置
            lmsMaxRetries: '最大重試次數',
            lmsBaseTimeout: '基礎逾時',
            lmsBackoffMultiplier: '退避倍數',
            lmsMaxQueueSize: '最大佇列大小',

            // LMS 時間配置
            lmsDynamicValidityMinutes: '動態有效期',
            lmsHeartbeatInterval: 'LMS 心跳',
            lmsMaxClockDrift: '最大時鐘偏移',
            lmsValidityBuffer: '有效性緩衝',
        },
        helpers: {
            // 伺服器配置
            port: 'OCPP 伺服器監聽的 WebSocket 連接埠',
            logOcppMessages: '啟用 OCPP 協定訊息的詳細記錄',
            heartbeatInterval: '伺服器發送心跳訊息的頻率（毫秒）',
            meterValueInterval: '發送電表數值的頻率（毫秒）',
            enableAuth: '要求 OCPP 連線進行認證',
            enableLMS: '啟用負載管理系統功能',

            // LMS 核心配置
            rebalanceInterval: '負載管理重新平衡的頻率（毫秒）',
            minRebalanceInterval: '重新平衡操作之間的最小時間（毫秒）',
            lmsIecMinimumCurrent: 'IEC 61851 最小電流（安培）',
            lmsPracticalMinimumCurrent: '故障安全配置檔的實際最小電流（安培）',
            lmsHysteresisThreshold: '應用的最小電流變化（安培）',
            lmsProfileRefreshInterval: '重新整理充電配置檔的頻率（毫秒）',
            lmsFailSafeCheckInterval: '驗證故障安全配置檔的頻率（毫秒）',

            // LMS 訊息配置
            lmsMaxRetries: '失敗訊息的最大重試次數',
            lmsBaseTimeout: '訊息回應的初始逾時（毫秒）',
            lmsBackoffMultiplier: '重試退避延遲的倍數',
            lmsMaxQueueSize: '佇列訊息的最大數量',

            // LMS 時間配置
            lmsDynamicValidityMinutes: '動態充電配置檔的有效期（分鐘）',
            lmsHeartbeatInterval: 'LMS 的預期心跳間隔（秒）',
            lmsMaxClockDrift: '可接受的最大時鐘偏移（秒）',
            lmsValidityBuffer: '網路延遲的緩衝時間（秒）',
        },
        resetToDefaults: '重設為預設值',

        // 舊版欄位，用於向後相容
        heartbeatInterval: '心跳間隔（秒）',
        connectionTimeout: '連線逾時（秒）',
        messageTimeout: '訊息逾時（秒）',
        maxRetries: '最大重試次數',
        retryDelay: '重試延遲（秒）',
        logLevel: '日誌層級',
        enableDebug: '啟用除錯模式',
        enableMetrics: '啟用指標收集',
        customHeaders: '自訂標頭（JSON）',
    },
    ipWhitelist: {
        title: 'IP 白名單',
        description: '新增允許連線的 IP 位址或 CIDR 範圍',
        emptyError: '請輸入 IP 位址',
        invalidError: '無效的 IP 位址或 CIDR 表示法',
        duplicateError: '此 IP 位址已在清單中',
        emptyList: '未配置 IP 限制。允許所有 IP。',
        helperText: '支援 IPv4、IPv6 和 CIDR 表示法（例如：192.168.1.0/24）',
    },
    active: '啟用',
    helpers: {
        name: '此 OCPP 伺服器的唯一名稱',
        description: '伺服器用途的可選描述',
        status: '目前營運狀態',
        endpointUrl: 'OCPP 伺服器端點的完整網址（例如：ws://ocpp.example.com:8888，http://ocpp.example.com:8787）',
        apiKey: '用於與 OCPP 伺服器進行身份驗證的 API 金鑰',
        webhookSecret: '用於 Webhook 驗證的可選密鑰',
        connectionTimeout: '連線逾時（毫秒）',
        messageTimeout: '訊息逾時（毫秒）',
        maxRetries: '最大重試次數',
        maxConcurrentSessions: '此伺服器可處理的最大並發充電時段數',
    },
    validation: {
        nameTooLong: '名稱必須少於 100 個字元',
        descriptionTooLong: '描述必須少於 500 個字元',
        invalidUrl: '必須是以 ws://、wss://、http:// 或 https:// 開頭的有效網址',
        urlTooLong: '網址必須少於 500 個字元',
        apiKeyTooLong: 'API 金鑰必須少於 200 個字元',
        webhookSecretTooLong: 'Webhook 密鑰必須少於 200 個字元',
    },
    info: {
        connectionNote: '啟用前請確保端點網址可存取且 API 金鑰有效',
        capabilitiesNote: '根據您的 OCPP 伺服器支援的功能啟用相應選項',
    },
    notifications: {
        createSuccess: 'OCPP 伺服器建立成功',
        updateSuccess: 'OCPP 伺服器更新成功',
        deleteSuccess: 'OCPP 伺服器刪除成功',
        deleteError: '刪除 OCPP 伺服器時發生錯誤',
        apiKeyRegenerated: 'API 金鑰重新產生成功',
        apiKeyRegenerateError: '重新產生 API 金鑰失敗',
        webhookSecretRegenerated: 'Webhook 密鑰重新產生成功',
        webhookSecretRegenerateError: '重新產生 Webhook 密鑰失敗',
        keysRegenerated: '新金鑰產生成功',
        apiKeyCopied: 'API 金鑰已複製到剪貼簿',
        webhookSecretCopied: 'Webhook 密鑰已複製到剪貼簿',
        ocppToBackendApiKeyCopied: 'OCPP 到後端 API 金鑰已複製到剪貼簿',
        backendToOcppApiKeyCopied: '後端到 OCPP API 金鑰已複製到剪貼簿',
    },
    delete: {
        title: '刪除 OCPP 伺服器',
        warning: '警告：此操作無法復原！',
        message: '您即將永久刪除 OCPP 伺服器',
        content: '刪除此 OCPP 伺服器配置。此操作無法復原。',
        isActiveContent: '無法刪除啟用中的 OCPP 伺服器。請先將其設為停用。',
        prompt: '要確認刪除，請輸入伺服器名稱',
        promptBelow: '如下：',
        typePlaceholder: '在此輸入伺服器名稱',
        nameDoesNotMatch: '伺服器名稱不符',
        button: '刪除 OCPP 伺服器',
    },
};